module.exports = __webpack_public_path__ + "static/media/438204601_963136645192191_2519000029665708500_n.a9c79d4e.png";